const dayOfWeeks = [
  {
    key: 1,
    Title: "Thứ hai",
  },
  {
    key: 2,
    Title: "Thứ ba",
  },
  {
    key: 3,
    Title: "Thứ tư",
  },
  {
    key: 4,
    Title: "Thứ năm",
  },
  {
    key: 5,
    Title: "Thứ sáu",
  },
  {
    key: 6,
    Title: "Thứ bảy",
  },
  {
    key: 0,
    Title: "Chủ nhật",
  },
];

export { dayOfWeeks };
